import { t } from 'i18next';
import { ChangeEventHandler } from 'react';

import { Button, DateInput, IconSvg, InputSearch, Text } from '@/lib/v2/components';
import { eventOnChangeDateInput } from '@/lib/v2/components/DateInput/DateInput';
import { CleanFiltersIcon, FilterIcon } from '@/lib/v2/icons/solid';
import { TableControlPanel } from '@/lib/v2/organisms';

import { DropdownFilterSection } from '@/src/modules/AutomationModuleNew/components/DropdownFilterSection';
import { CheckboxItems } from '@/src/modules/AutomationModuleNew/components/DropdownFilterSection/DropdownFilterSection';

type FiltersTableProps = {
  placeholderInput?: string;
  dropdownItemsFilter: CheckboxItems;
  onClickApplyFilter?: (checkedItems: CheckboxItems) => void;
  onClickClearFilters?: () => void;
  isScrollable?: boolean;
  onChangeInputSearch?: ChangeEventHandler<HTMLInputElement>;
  valueInputSearch?: string;
  onClickApplySearch?: (value: string) => void;
  onChangeCheckbox?: (isChecked: boolean, section: string, index: number) => void;
  onClearFilters?: () => void;
  startDate?: Date | null;
  endDate?: Date | null;
  placeholderDate?: string;
  enableDateFilter?: boolean;
  onChangeDate?: eventOnChangeDateInput;
  actionBarComponent?: React.ReactNode;
  enableActionBar?: boolean;
  totalRowSelected?: number;
  isClearButtonDisabled?: boolean;
  filterText?: string;
};

const FiltersTable = ({
  placeholderInput,
  dropdownItemsFilter,
  isScrollable = false,
  onChangeInputSearch,
  valueInputSearch,
  onClickApplySearch,
  onClickApplyFilter,
  onChangeCheckbox,
  onClearFilters,
  startDate,
  endDate,
  placeholderDate,
  enableDateFilter = true,
  onChangeDate,
  actionBarComponent,
  enableActionBar = false,
  totalRowSelected,
  isClearButtonDisabled,
  filterText,
}: FiltersTableProps) => {
  return (
    <div className="sticky top-0 z-20 mb-[-62px] w-[calc(100%-300px)]">
      <TableControlPanel>
        {enableActionBar ? (
          <TableControlPanel.Tools selectedItems={totalRowSelected}>
            {actionBarComponent}
          </TableControlPanel.Tools>
        ) : (
          <TableControlPanel.Filters>
            <div className="flex size-full items-center gap-2">
              <div className="w-[280px]">
                <InputSearch
                  standard
                  placeHolder={placeholderInput}
                  value={valueInputSearch}
                  onAction={onClickApplySearch}
                  onChange={onChangeInputSearch}
                  onClear={() => onClickApplySearch?.('')}
                />
              </div>
              {enableDateFilter && (
                <DateInput
                  selectsRange
                  endDate={endDate}
                  maxDate={new Date()}
                  placeholder={placeholderDate}
                  startDate={startDate}
                  onChange={onChangeDate}
                />
              )}
              <DropdownFilterSection
                applyButtonText={t('FiltersTable.apply')}
                dropdownItems={dropdownItemsFilter}
                icon={<IconSvg fillColor="gray-dark" svgComponent={<FilterIcon />} />}
                isScrollable={isScrollable}
                label={t('FiltersTable.filters')}
                onChangeCheckbox={onChangeCheckbox}
                onClickApplyFilter={onClickApplyFilter}
              />
              <Button
                gray
                outline
                standard
                disabled={isClearButtonDisabled}
                id="clear-filters"
                onClick={onClearFilters}
              >
                <IconSvg fillColor="gray-dark" svgComponent={<CleanFiltersIcon />} />
              </Button>
              {filterText && (
                <Text isItalic variant="text">
                  {filterText}
                </Text>
              )}
            </div>
          </TableControlPanel.Filters>
        )}
      </TableControlPanel>
    </div>
  );
};

export default FiltersTable;
